<div *ngIf="model() || additionalResources">
  <div class="resource-container" [class.has-two-resources-overflow]="hasTwoResourcesOverflow">
    <div
      *ngIf="model(); else showArrayResources"
      #actualTarget
      (mouseover)="showOverlayPanel($event, actualTarget, overlayPanel)"
      (mouseleave)="overlayPanel.hide()"
      [ngClass]="{ 'single-resource': isSingleResource, visible: clickActive }"
      class="resource"
    >
      <u-icon
        *ngIf="referenceIndex"
        class="reference"
        [ngClass]="{ 'resource-active': resourceActiveIndex == referenceIndex }"
        [model]="{ type: 'font-icon', value: 'icon-number-' + referenceIndex }"
      ></u-icon>
      <ng-container *ngIf="model()?.view?.icon">
        <u-icon class="resource-icon" [model]="iconModel()" [fallback]="fallbackIcon()" [styles]="{ backgroundSize: 'contain' }"></u-icon>
      </ng-container>
      <span *ngIf="model()?.view?.title?.text" class="text" [innerHTML]="model().view.title.text | removeNewLine | richTextFormatted">
      </span>
      @if (resourceModel().resource?.data.verificationStatus) {
        <u-icon
          class="verification-status"
          [model]="{
            type: 'img',
            value: {
              lightUrl:
                resourceModel().resource?.data.verificationStatus === 'Verified'
                  ? './assets/verification/verified-light.svg'
                  : './assets/verification/unverified-light.svg',
            },
          }"
        >
        </u-icon>
      }
    </div>
    <p-overlayPanel #overlayPanel [dismissable]="false" [styleClass]="'overlay'">
      <resource-panel [model]="model()" [fallbackIcon]="fallbackIcon()" [searchId]="searchId"></resource-panel>
    </p-overlayPanel>

    <ng-template #showArrayResources>
      <span class="resource">
        <span (click)="clickAdditionalResources()">
          {{ seeAll ? 'See All' : '+' + additionalResources.length + ' resources' }}
        </span>
      </span>
    </ng-template>
  </div>
</div>
